<template>
  <main>
    <slot name="content">
      <!-- Default content if no slot is provided -->
      <p>Oops some content is missing here...</p>
    </slot>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

// const childValue = ref<string>(''); // Valor recibido del hijo
const footerRef = ref<HTMLElement | null>(null);
const footerHeight = ref<number>(0);

// const handleExpandedValue = (value: string): void => {
//   childValue.value = value;
// };

const checkHeight = () => {
  if (footerRef.value) {
    footerHeight.value = footerRef.value.offsetHeight;
  }
};

onMounted(() => {
  checkHeight();
  window.addEventListener("resize", checkHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkHeight);
});
</script>

<style scoped lang="scss">
@import 'SimpleLayout';
</style>